export default "__VITE_ASSET__PwuYnkyl__"